import { startCacheWorker } from '@betterment/js-runtime';
import { dropdowns, faqs } from '@betterment/style-closet-legacy';
import Rails from '@rails/ujs';
import jQuery from 'jquery';
import Turbolinks from 'turbolinks';

import { startStimulusApplication } from '../../index';

import '../vendor/jSignature';
import '../vendor/jQuerySpinnerPlugin';
import '../vendor/webshim.range-input';
import '../vendor/modernizr';
import '../vendor/d3';
import '../scripts/behaviors';
import '../scripts/form_behaviors';
import '../scripts/turbolinks_workarounds';

(window as any).$ = jQuery;
(window as any).jQuery = jQuery;
window.Turbolinks = Turbolinks;

Turbolinks.start();

dropdowns();
faqs();

if (!window._rails_loaded) Rails.start();

void startStimulusApplication();
startCacheWorker();
